import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { ThemeStore } from "./store/ThemeStore";
import ThemeInitializer from "./components/ThemeInitializer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={ThemeStore}>
      <ThemeInitializer />
      <App />
    </Provider>
  </React.StrictMode>
);
